import MetaAttentionCountersResponse from "../../../api/raily/meta/attention-counters/meta-attention-counters.response";
import MetaAttentionCounters from "./meta-attention-counters";

const create = (
  response: MetaAttentionCountersResponse,
): MetaAttentionCounters => {
  const data = response.data;

  return {
    activeOrders: data.activeOrders,
    forwardingNotYetBilledTaxi: data.forwardingNotYetBilledTaxi,
    orderBillingsCargo: data.orderBillingsCargo,
    orderNotYetBilledTaxi: data.orderNotYetBilledTaxi,
    routeNotYetBilledTaxi: data.routeNotYetBilledTaxi,
  };
};

const metaAttentionCountersFactory = {
  create,
};

export default metaAttentionCountersFactory;
